<div class="flex flex-column items-center">
  <div class="text-center">
    <i class="pi pi-clock" style="color: slateblue; font-size: 2.5rem"></i>
  </div>
  <p class="text-muted-color text-center block mt-2 mb-2">
    Se ha modificado la fecha de entrega
  </p>
  <div class="flex mt-2 justify-content-center">
    <p-button type="submit" label="Ok" (onClick)="closeModal()" />
  </div>
</div>
